<ape-admin-page-container
  class="w-full h-full flex flex-col self-stretch flex-1"
  [title]="TRANSLATION_KEYS.admin.impersonate.TITLE | translate"
  [showBackButton]="true"
  (backClick)="onBackAction()"
>
  <!-- Loading state con skeleton -->
  <ng-container *ngIf="showSkeletonLoader; else contentTemplate">
    <ape-admin-impersonate-skeleton/>
  </ng-container>

  <ng-template #contentTemplate>
    <!-- Tabella con search bar e placeholder integrati -->
    <ape-admin-impersonate-table
      [users]="users"
      [searchValue]="searchValue"
      [loading]="loading"
      [totalItems]="totalItems"
      [page]="page"
      [pageSize]="pageSize"
      (searchChange)="onSearchChange($event)"
      (search)="onSearch($event)"
      (impersonateEmployee)="onImpersonateEmployee($event)"
      (impersonateManager)="onImpersonateManager($event)"
    />
  </ng-template>
</ape-admin-page-container>
